/* Fashiyano theme JS — drawers, carousels, product form, cart */
(() => {
  'use strict';

  const veil = document.querySelector('[data-veil]');
  let openDrawer = null;

  /* ---------- Drawers ---------- */
  function drawerOpen(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (openDrawer && openDrawer !== el) drawerClose();
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    if (veil) {
      veil.hidden = false;
      requestAnimationFrame(() => veil.classList.add('is-open'));
    }
    document.body.classList.add('is-locked');
    openDrawer = el;
    const focusable = el.querySelector('input:not([type=hidden]), button, a');
    if (focusable) setTimeout(() => focusable.focus(), 300);
  }

  function drawerClose() {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('aria-hidden', 'true');
    if (veil) {
      veil.classList.remove('is-open');
      setTimeout(() => { if (!openDrawer) veil.hidden = true; }, 450);
    }
    document.body.classList.remove('is-locked');
    openDrawer = null;
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      drawerOpen(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      drawerClose();
    }
  });

  if (veil) veil.addEventListener('click', drawerClose);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') drawerClose();
  });

  /* ---------- Header scroll state ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 24);
      header.classList.toggle('is-hidden', y > 380 && y > last && !openDrawer);
      last = y;
    }, { passive: true });
  }

  /* ---------- Reveal on scroll ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (en.isIntersecting) {
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  document.querySelectorAll('.reveal, .reveal-stagger, .thread-svg').forEach((el) => io.observe(el));

  /* ---------- Announcement dismiss ---------- */
  document.querySelectorAll('[data-announcement-dismiss]').forEach((btn) => {
    const bar = btn.closest('[data-announcement]');
    if (sessionStorage.getItem('fy-announcement-hidden')) bar.style.display = 'none';
    btn.addEventListener('click', () => {
      bar.style.display = 'none';
      sessionStorage.setItem('fy-announcement-hidden', '1');
    });
  });

  /* ---------- Carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach((root) => {
    const track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    const step = () => {
      const item = track.firstElementChild;
      if (!item) return 0;
      const gap = parseFloat(getComputedStyle(track).columnGap || '0');
      return item.getBoundingClientRect().width + gap;
    };
    root.querySelectorAll('[data-carousel-prev]').forEach((b) =>
      b.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }))
    );
    root.querySelectorAll('[data-carousel-next]').forEach((b) =>
      b.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }))
    );
  });

  /* ---------- Hero slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-slide]')];
    const dots = [...root.querySelectorAll('[data-slide-dot]')];
    if (slides.length < 2) return;
    let i = 0;
    let timer = null;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const play = () => {
      clearInterval(timer);
      timer = setInterval(() => show(i + 1), parseInt(root.dataset.interval || '6000', 10));
    };
    dots.forEach((d, k) => d.addEventListener('click', () => { show(k); play(); }));
    show(0);
    play();
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const input = btn.closest('.qty').querySelector('.qty__input');
    const delta = parseInt(btn.dataset.qtyChange, 10);
    const next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart (drawer + page) ---------- */
  async function refreshCart(openAfter) {
    const res = await fetch(`${window.location.pathname}?sections=cart-drawer`);
    const data = await res.json();
    const holder = document.getElementById('CartDrawer');
    if (holder && data['cart-drawer']) {
      const dom = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = dom.getElementById('CartDrawer');
      if (fresh) holder.innerHTML = fresh.innerHTML;
    }
    const bubble = document.querySelector('[data-cart-count]');
    if (bubble) {
      const cart = await (await fetch('/cart.js')).json();
      bubble.textContent = cart.item_count;
      bubble.toggleAttribute('hidden', cart.item_count === 0);
    }
    if (openAfter) drawerOpen('CartDrawer');
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-atc]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to bag');
      }
      await refreshCart(true);
    } catch (err) {
      const note = form.querySelector('[data-form-error]');
      if (note) { note.textContent = err.message; note.hidden = false; }
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }
  });

  document.addEventListener('change', async (e) => {
    const line = e.target.closest('[data-line-qty]');
    if (!line) return;
    const key = line.dataset.lineKey;
    const qty = parseInt(line.querySelector('.qty__input').value, 10) || 0;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    if (document.body.contains(document.querySelector('[data-cart-page]'))) {
      window.location.reload();
    } else {
      refreshCart(false);
    }
  });

  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: rm.dataset.lineKey, quantity: 0 }),
    });
    if (document.querySelector('[data-cart-page]')) window.location.reload();
    else refreshCart(false);
  });

  /* ---------- Product form: variant selection ---------- */
  document.querySelectorAll('[data-product-wrap]').forEach((wrap) => {
    const dataEl = wrap.querySelector('[data-product-json]');
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = wrap.querySelector('form[data-product-form]');
    const idInput = form && form.querySelector('input[name="id"]');
    const priceEl = wrap.querySelector('[data-price]');
    const btn = wrap.querySelector('[data-atc]');
    const money = (cents) => {
      const fmt = wrap.dataset.moneyFormat || '₹{{amount}}';
      const amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 });
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };

    function currentVariant() {
      const chosen = [...wrap.querySelectorAll('[data-option-input]:checked, select[data-option-select]')]
        .map((el) => el.value);
      return product.variants.find((v) => v.options.every((o, k) => o === chosen[k]));
    }

    function sync() {
      const v = currentVariant();
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML =
          `<span class="price__current">${money(v.price)}</span>` +
          (v.compare_at_price > v.price
            ? ` <s class="price__was">${money(v.compare_at_price)}</s>`
            : '');
        priceEl.classList.toggle('price--on-sale', v.compare_at_price > v.price);
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? (btn.dataset.labelAdd || 'Add to bag') : 'Sold out';
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      const featured = v.featured_image && v.featured_image.src;
      if (featured) {
        const main = wrap.querySelector('[data-gallery-main] img');
        if (main) main.src = featured;
      }
    }

    wrap.querySelectorAll('[data-option-input], select[data-option-select]').forEach((el) =>
      el.addEventListener('change', sync)
    );
    sync();
  });

  /* ---------- PDP gallery thumbs ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-gallery-thumb]');
    if (!t) return;
    const wrap = t.closest('[data-product-wrap]');
    const main = wrap && wrap.querySelector('[data-gallery-main] img');
    const img = t.querySelector('img');
    if (main && img) {
      main.src = img.dataset.full || img.src;
      wrap.querySelectorAll('[data-gallery-thumb]').forEach((x) => x.classList.remove('is-active'));
      t.classList.add('is-active');
    }
  });
})();
